import Logger from '../logger/logger';
import Storage from '../storage/storage';
import LocalStorageAdapter from '../storage/adapter/local-storage-adapter';

const appVersion = typeof VERSION !== 'undefined' && VERSION ? VERSION : 'latest'; // eslint-disable-line no-undef

/**
 * Version manager
 *
 * Sets the version in storage, if version is not up to date,
 * clear all keys and update storage version.
 */
export default function () {
  const storage = new Storage(LocalStorageAdapter);

  if (storage.getVersion() !== appVersion) {
    Logger.debug(`Keys removed for version ${storage.getVersion()}`);
    storage.removeByVersion(storage.getVersion());
    Logger.debug(`Version ${storage.getVersion()} updated to ${appVersion}`);
    storage.setVersion(appVersion);
  }
}
